import { render, staticRenderFns } from "./VoidReason.vue?vue&type=template&id=648004b6"
import script from "./VoidReason.vue?vue&type=script&lang=js"
export * from "./VoidReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports